import Vue from 'vue'
import App from './App.vue'
import router from './router'
//icon图标
import './assets/icon/iconfont.css'
// ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
Vue.use(ElementUI);

//轮播图
import './assets/js/swiper-bundle.min.css';
import './assets/js/swiper-bundle.min.js'

// import './assets/js/swiper.min.css';
// // import './assets/js/colormad.css';
// import './assets/js/jquery-2.2.0.min.js'
// import './assets/js/swiper.min.js'
// import './assets/js/anime.min.js'

// 接口
import axios from 'axios'
Vue.prototype.axiox=axios;
Vue.prototype.$http = axios;
// vuex
import store from './store'
// less
import less from 'less'
Vue.use(less)
//jquery
import $ from 'jquery'
Vue.use($)
// 数字动画
import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')